var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var overArg = require('./_overArg');
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys = overArg(_Object$keys, Object);
module.exports = nativeKeys;